"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValidToken = exports.isJTWToken = void 0;
var isJTWToken = function isJTWToken(token) {
  return /(^[\w-]*\.[\w-]*\.[\w-]*$)/.test(token);
};
exports.isJTWToken = isJTWToken;
var hasValidToken = function hasValidToken(token) {
  if (!token || !(0, exports.isJTWToken)(token)) {
    return false;
  }
  var decodedToken = JSON.parse(atob(token.split('.')[1]));
  var expiryTimestamp = decodedToken.exp;
  var currentTimestamp = new Date().getTime() / 1000;
  return !(!expiryTimestamp || expiryTimestamp && expiryTimestamp <= currentTimestamp);
};
exports.hasValidToken = hasValidToken;
//# sourceMappingURL=index.js.map